import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const multilingualRuntime = createHostModule({
    currentLanguage: ({ channel }) => function currentLanguage(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'multilingual.currentLanguage',
            args,
        });
    },
    isEnabled: ({ channel }) => function isEnabled(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'multilingual.isEnabled',
            args,
        });
    },
    siteLanguages: ({ channel }) => function siteLanguages(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'multilingual.siteLanguages',
            args,
        });
    },
});
//# sourceMappingURL=multilingual.runtime.js.map